import { SVGProps } from 'react';

export const EyeToSeeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00059 3.5C5.12896 3.5 2.69105 5.36249 1.8314 7.94677C1.81954 7.98243 1.81955 8.02118 1.83143 8.05683C2.69215 10.6392 5.12913 12.5 7.99942 12.5C10.871 12.5 13.309 10.6375 14.1686 8.05323C14.1805 8.01757 14.1805 7.97882 14.1686 7.94317C13.3079 5.36076 10.8709 3.5 8.00059 3.5ZM0.882518 7.63113C1.87402 4.65047 4.68552 2.5 8.00059 2.5C11.3141 2.5 14.1245 4.64848 15.1173 7.62697C15.1975 7.86768 15.1976 8.12812 15.1175 8.36887C14.126 11.3495 11.3145 13.5 7.99942 13.5C4.68589 13.5 1.87547 11.3515 0.882737 8.37303C0.802509 8.13233 0.802432 7.87188 0.882518 7.63113ZM5.50005 8C5.50005 6.61929 6.61934 5.5 8.00005 5.5C9.38076 5.5 10.5 6.61929 10.5 8C10.5 9.38071 9.38076 10.5 8.00005 10.5C6.61934 10.5 5.50005 9.38071 5.50005 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
